import React from 'react';
import { PatientInviteReceiver } from '../../patient-invite.types';
import { Flex } from '@common/components/Flex';
import { I18n } from 'react-redux-i18n';
import { getTestAttributes } from '@common/utils/tests';
import { Radio } from '@common/components/radio';

import './receiver-chooser.styles.scss';

export type ReceiverChooserProps = {
  value?: PatientInviteReceiver;
  onChange: (value: PatientInviteReceiver) => void;
};

export const ReceiverChooser: React.FC<ReceiverChooserProps> = (props) => { 
  const { value, onChange } = props;

  const config = React.useMemo(() => {
    return [
      {
        title: I18n.t('New Patient'),
        options: [
          { 
            label: I18n.t('New Patient'), 
            value: PatientInviteReceiver.newPatient, 
            id: 'radio-bw-quest-invites-step2-radio-cr-new-patient-group-input',
          },
        ]
      },
      {
        title: I18n.t('Existing patient or relative'),
        options: [
          { 
            label: I18n.t('Individual'), 
            value: PatientInviteReceiver.individual, 
            id: 'radio-bw-quest-invites-step2-radio-cr-individual-group-input',
          },
          { 
            label: I18n.t('Members of one family'), 
            value: PatientInviteReceiver.membersOfOneFamily, 
            id: 'radio-bw-quest-invites-step2-radio-cr-family-members-group-input',
          },
          { 
            label: I18n.t('Patients who meet specific criteria'), 
            value: PatientInviteReceiver.patientsWhoMeetCriteria, 
            id: 'radio-bw-quest-invites-step2-radio-cr-patient-criteria-group-input',
          },
        ]
      },
    ];
  }, []);

  const handleChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value as PatientInviteReceiver);
  }, [onChange]);

  return (
    <div className="InviteStatusReceiverChooser">
      <h6 className="InviteStatusReceiverChooser__title">{I18n.t('Who would you like to invite?')}</h6>
      <Flex justify="center">
        {config.map((group, index) => (
          <div key={index} className="InviteStatusReceiverChooser__section">
            <h6 className='InviteStatusReceiverChooser__title'>{group.title}</h6>
            {group.options.map((option) => (
              <Radio
                key={option.value}
                className="InviteStatusReceiverChooser__item"
                value={option.value}
                checked={value === option.value}
                onChange={handleChange}
                {...getTestAttributes({ id: option.id })}
              >
                {option.label}
              </Radio>
            ))}
          </div>
        ))}
      </Flex>
    </div>
  );
};